import React from "react";
import { Spin } from "antd";
import { useTranslation } from "react-i18next";

export const Loading = () => {
  const { t } = useTranslation();

  return (
    <div className="spor-loading min-h-screen bg-[#F4F3EF]">
      <Spin size="large" />
      <p className="text-[#64748B] text-base font-medium">{t("common.loading")}</p>
    </div>
  );
};
